import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { useSelector } from 'react-redux';
import { currentIterationSelector } from 'state/selectors/iterations-picker';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { TrakingEventPayload } from './iteration-summary.model';

const useIterationSummaryEventsTracker = ({ insightId = null } = {}) => {
  const page = TRACKING.PAGES.PULSE;
  const insight = 'iteration summary';

  const currentIteration = useSelector(currentIterationSelector);
  const selectedTeam = useSelector(selectedTeamSelector);

  const trackEvent = (eventType: string, payload: TrakingEventPayload) => {
    TrackingService.logEvent(eventType, {
      page,
      insight,
      iteration_id: currentIteration?.id,
      team_id: selectedTeam?.id,
      ...(insightId ? { insight_id: insightId } : {}),
      ...payload
    });
  };

  const onOpen = () => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.ITERATION_SUMMARY.OPEN
    });
  };

  const onClose = () => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.ITERATION_SUMMARY.CLOSE
    });
  };

  const onFeedback = ({
    feedbackType,
    feedbackSection,
    feedbackComment = null
  }) => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.ITERATION_SUMMARY.FEEDBACK,
      feedback_type: feedbackType,
      feedback_section: feedbackSection,
      ...(feedbackComment ? { feedback_comment: feedbackComment } : {})
    });
  };

  const onCopyMarkdown = () => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.ITERATION_SUMMARY.COPY_MARKDOWN
    });
  };

  const onCopyLink = () => {
    trackEvent(TRACKING.EVENTS.CLICK, {
      click_type: TRACKING.CLICK.ITERATION_SUMMARY.COPY_LINK
    });
  };

  const onViewButtonHover = () => {
    trackEvent(TRACKING.EVENTS.HOVER, {
      hover_type: TRACKING.HOVER.ITERATION_SUMMARY.VIEW_BUTTON
    });
  };

  const onShareButtonHover = () => {
    trackEvent(TRACKING.EVENTS.HOVER, {
      hover_type: TRACKING.HOVER.ITERATION_SUMMARY.SHARE_BUTTON
    });
  };

  const onLinkVisit = (source: string) => {
    trackEvent(TRACKING.EVENTS.VISIT, {
      source
    });
  };

  return {
    onOpen,
    onClose,
    onFeedback,
    onCopyMarkdown,
    onCopyLink,
    onViewButtonHover,
    onShareButtonHover,
    onLinkVisit
  };
};

export default useIterationSummaryEventsTracker;
